var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"auth_challenge"}},[_vm._m(0),_c('h1',[_vm._v(_vm._s(_vm.$t('authentificateChallenge.header')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('authentificateChallenge.body'))}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-spinner"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }